<template>
  <div class="page_wrapper">
    <p></p>
    <div class="box_solid">
      <h3>Event Livestream</h3>
      <div class="video_container" v-show="true">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/myHfCzGBqeU" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
<!--        <video class="video" v-show="playing" ref="liveVideo" controls></video>-->
<!--        <button @click="playStream" v-show="url_found">Play</button>-->
        <h4 v-show="!url_found">The Web Stream is hosted on youtube. <a href="https://www.youtube.com/watch?v=myHfCzGBqeU">https://www.youtube.com/watch?v=myHfCzGBqeU</a></h4>
<!--        <h4 v-show="!hcl_supported"> Your browser is not supported.</h4>-->
<!--        <h4 v-show="hcl_supported">If the video bar is spinning for more than 30-120 Seconds please refresh the page.</h4>-->
      </div>
      <div v-show="!true">
        Please Login to view our live stream.
        <br>
        <button @click="login">Login</button>
      </div>

    </div>
  </div>
</template>

<script>

import Firebase from "@/firebase";
import Hls from 'hls.js'

export default {
  name: "Live",
  data () {
    return {
      user: {
        loggedIn: false,
        data: {}
      },
      url_found: false,
      data_got: {},
      hcl_supported: false,
      native_supported: false,
      playing: false,
    }
  },
  methods: {
    login() {
      Firebase.login();
    },
    playStream() {
      if(!this.playing) {
        if (this.native_supported) {
          this.$refs.liveVideo.src = this.data_got
        } else if (this.hcl_supported) {
          let hls;
          hls = new Hls();
          hls.loadSource(this.data_got);
          hls.attachMedia(this.$refs.liveVideo);
        }
        this.playing = true
      }
      this.$refs.liveVideo.play()
    },
    updateStream() {
      if (this.native_supported) {
        this.$refs.liveVideo.src = this.data_got
      } else if (this.hcl_supported) {
        let hls;
        hls = new Hls();
        hls.loadSource(this.data_got);
        hls.attachMedia(this.$refs.liveVideo);
      }
      this.playing = true
      this.$refs.liveVideo.play()
    }
  },
  mounted: function() {
    Firebase.auth.onAuthStateChanged( user => {
      if (user) {
        this.user.loggedIn = true;
        this.user.data = user;
        // Firebase.db.ref('live/default').on('value', (snapshot) => {
        //   if (snapshot.val()) {
        //     console.log(snapshot.val());
        //     if (snapshot.val() !== "") {
        //       this.url_found = true;
        //       this.data_got = snapshot.val();
        //     }
            //alert(JSON.stringify(snapshot.val()));

        //     if (this.playing) {
        //       this.updateStream()
        //     }
        //   }
        // })
      }
      else {
        this.user.loggedIn = false;
        this.user.data = {};
      }
    })
    this.native_supported = !!this.$refs.liveVideo.canPlayType('application/vnd.apple.mpegurl');
    if (!this.native_supported) {
      this.hcl_supported = Hls.isSupported()
    }else {
      this.hcl_supported = true
    }


  }
};
</script>

<style scoped>

</style>
